import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  SimpleChanges,
  SimpleChange,
  OnDestroy
} from "@angular/core";
import { GeneralService } from "src/app/services/general.service";
import * as localForage from "localforage";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { CommunicationCommand } from "../../models/communicationCommands";
import { MerchantItems } from "src/app/models/items";
import { CommunicationService } from "src/app/services/communication.service";
import { timeout } from "rxjs/operators";
import { TimeoutError, Subscription } from "rxjs";
import { HttpErrorResponse } from "@angular/common/http";
import { Catalogue } from "src/app/models/catalogueDescriptor";
import { MockStoreService } from "src/app/services/mock-store.service";

@Component({
  selector: "app-add-catalogue",
  templateUrl: "./add-catalogue.component.html",
  styleUrls: ["./add-catalogue.component.css"]
})
export class AddCatalogueComponent implements OnInit, OnDestroy {
  @Output("closeModal") closeModal = new EventEmitter();
  @Input("itemsSelected") itemsSelected: MerchantItems[];
  @Input("editingInProgress") editMode: any;
  @Input("viewCatalogue") viewCatalogue: Catalogue;
  selection: boolean = false;
  addCatalogueForm: FormGroup;
  arrayOfPicturesAttachedToCatalogue = Array(10);
  countOfTruePictures: number = 0;
  catalogueInViewMode: Catalogue;
  catalogueInEditMode: Catalogue;
  destroyItems: Subscription;

  constructor(
    private generalservice: GeneralService,
    private commservice: CommunicationService,
    public mockstore: MockStoreService,
    private fb: FormBuilder
  ) {
    this.fillUpArrayWithDummyPictures();
    // console.log(this.arrayOfPicturesAttachedToCatalogue);
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log(changes);
    try {
      // sets view catalogue in motion
      if (
        changes.hasOwnProperty("viewCatalogue") &&
        changes.viewCatalogue.currentValue
      ) {
        this.showViewPage(changes.viewCatalogue);
        return;
      }
      // sets edit catalogue in motion
      if (changes.hasOwnProperty("editMode") && changes.editMode.currentValue) {
        this.setEditingInMotion(changes.editMode);
        return;
      }
      // if (changes.hasOwnProperty("editMode")) {
      //   this.setEditingInMotion(changes.editMode);
      //   return;
      // }
      //  sets items selected from view selection component
      if (
        changes.hasOwnProperty("itemsSelected") &&
        changes.itemsSelected.currentValue.length > 0
      ) {
        this.managePictureCatalogue(changes);
      }
    } catch (error) {
      console.log(error);
    }
  }

  ngOnInit(): void {
    (document.querySelectorAll(".owl-dots")[2] as HTMLElement).hidden = true;
    this.addCatalogueForm = this.fb.group({
      name: ["", Validators.required],
      description: ["", Validators.required]
    });

    // i am resetting the function in case the user is trying to add a new catalogue
    this.destroyItems = this.generalservice.addItem$.subscribe(val => {
      if (typeof val == "string" && val.trim() == "addCatalogue") {
        this.addCatalogueForm.reset();
        this.fillUpArrayWithDummyPictures();
        this.mockstore.viewCatalagueMode = false;
        this.mockstore.editCatalogueMode = false;
      }
      if (
        val instanceof CommunicationCommand &&
        val.action == "view" &&
        val.component == "catalogue"
      ) {
        this.addCatalogueForm.reset();
        this.fillUpArrayWithDummyPictures();
        this.mockstore.editCatalogueMode = false;
        // this.mockstore.viewCatalagueMode = true;
      }
    });
    // console.log(document.querySelectorAll(".owl-dots") as NodeList);
  }

  // getters for form
  get name() {
    return this.addCatalogueForm.get("name");
  }

  get description() {
    return this.addCatalogueForm.get("description");
  }
  // triggers the function to add new Items
  startAddingItems() {}

  // this function toggles on the view page section
  showViewPage(view: SimpleChange) {
    this.mockstore.viewCatalagueMode = true;
    const { payload } = view.currentValue;
    this.catalogueInViewMode = payload;
  }

  // submit the catalogues
  submitCatalogueForm(form: FormGroup, event: Event) {
    if (event instanceof KeyboardEvent && event.code.includes("Enter")) {
      return;
    }
    if (!window.navigator.onLine) {
      this.generalservice.warningNotification(
        "You are offline. Please check your internet connection and try again"
      );
      return;
    }
    const currentForm = event.srcElement as HTMLFormElement;
    const button = currentForm.querySelector("button");
    button.innerText = "ADDING ....";
    if (!form.valid) {
      this.generalservice.warningNotification(`You have not filled the form!`);
      return;
    }

    if (this.addedCatalogueItemsCount < 1) {
      this.generalservice.warningNotification(
        `You have to add at least an item to the catalogue!`
      );
      return;
    }
    let formTosubmit = { ...form.value };
    const catalogue_item_ids = [];
    this.arrayOfPicturesAttachedToCatalogue.forEach(element => {
      if (element.id != null) {
        catalogue_item_ids.push(element.id);
      }
    });
    formTosubmit = { ...formTosubmit, catalogue_item_ids };
    if (this.mockstore.editCatalogueMode) {
      button.textContent = "EDITING...";
      this.submitEditedCatalogue(
        formTosubmit,
        this.catalogueInEditMode.id,
        form,
        button
      );
      return;
    }
    this.commservice
      .addCatalogue(formTosubmit)
      .pipe(timeout(50000))
      .subscribe(
        val => {
          this.handleSuccessfulSubmit(val, form, button);
        },
        err => this.handleSubmittingErrors(err, form, button)
      );
  }
  // saves the currentForm user has filled, and closes the
  // form for user to select items;
  async addFromMerchantsExistingItem() {
    // debugger;
    if (
      this.mockstore.addingDirectlyFromCatalogueListing &&
      this.mockstore.comingFromCatalogueListingComponent
    ) {
      this.selection = false;
      this.generalservice.startFetchingSelectionItems("start");
      this.close();
      this.generalservice.switchSidebarOnOrOff({
        switcher: "on",
        message: "view-items"
      });
      return;
    }
    let form = {
      ...this.addCatalogueForm.value,
      ...this.arrayOfPicturesAttachedToCatalogue
    };
    this.selection = false;
    this.generalservice.startFetchingSelectionItems("start");
    try {
      await localForage.setItem("catalogueInProgress", form);
    } catch (error) {
      console.log(error);
    }
    this.close();
    this.generalservice.switchSidebarOnOrOff({
      switcher: "on",
      message: "view-items"
    });
  }

  // this function closes the current modal for selection to be started;
  close() {
    const comm = new CommunicationCommand(
      "close",
      undefined,
      "ItemsSelectionViewComponent"
    );
    this.closeModal.emit(comm);
  }

  // manages the array of pictures to be added to be catalogue
  managePictureCatalogue(changes) {
    const regex = /placeholder-img_2.jpg$/gi;
    let arrContainsNull: boolean;
    let array: MerchantItems[] = changes.itemsSelected.currentValue;
    if (array.length < 0) return;
    arrContainsNull = this.arrayOfPicturesAttachedToCatalogue.every(
      element => element.id == null
    );
    if (arrContainsNull) {
      let count = array.length;
      for (let i = count; i > 0; i--) {
        if (!this.arrayOfPicturesAttachedToCatalogue[i].id) {
          this.arrayOfPicturesAttachedToCatalogue.splice(i, 1);
        }
      }

      this.arrayOfPicturesAttachedToCatalogue = [
        ...array,
        ...this.arrayOfPicturesAttachedToCatalogue
      ];
    } else {
      let count = array.length;
      let deleteCount = this.arrayOfPicturesAttachedToCatalogue.length - 1;
      for (let i = deleteCount; i > 0; i--) {
        if (!this.arrayOfPicturesAttachedToCatalogue[i].id && 0 < count) {
          this.arrayOfPicturesAttachedToCatalogue.splice(i, 1);
        }
        count--;
      }
      this.arrayOfPicturesAttachedToCatalogue = [
        ...array,
        ...this.arrayOfPicturesAttachedToCatalogue
      ];
    }
  }

  // gets the current catalogue item.
  get addedCatalogueItemsCount(): number {
    let count: number = 0;
    this.arrayOfPicturesAttachedToCatalogue.forEach(element => {
      if (element.id !== null) count++;
    });
    return count;
  }
  // gets the remaining catalogue items to add
  get remainingCatalogueItems(): number {
    let count: number = 0;
    this.arrayOfPicturesAttachedToCatalogue.forEach(element => {
      if (element.id == null) count++;
    });
    return count;
  }

  //  remove an item
  removeItem(item: MerchantItems) {
    const index = this.arrayOfPicturesAttachedToCatalogue.findIndex(
      (element: MerchantItems) => element.id == item.id
    );
    this.arrayOfPicturesAttachedToCatalogue = this.arrayOfPicturesAttachedToCatalogue.filter(
      element => element.id != item.id
    );
    // push this null item to replace the one removed so that the array.length is maintained
    this.arrayOfPicturesAttachedToCatalogue.splice(index, 0, {
      id: null,
      primary_picture: "../../../assets/images/placeholder-img_2.jpg"
    });
    // this.arrayOfPicturesAttachedToCatalogue.push({
    //   id: null,
    //   primary_picture: "../../../assets/images/placeholder-img_2.jpg"
    // });

    // if (this.arrayOfPicturesAttachedToCatalogue.length > 10) {
    //   this.arrayOfPicturesAttachedToCatalogue.splice(
    //     this.arrayOfPicturesAttachedToCatalogue.length - 1,
    //     1
    //   );
    // }
    // console.log(this.arrayOfPicturesAttachedToCatalogue);
  }

  fillUpArrayWithDummyPictures() {
    this.arrayOfPicturesAttachedToCatalogue = this.arrayOfPicturesAttachedToCatalogue.fill(
      {
        id: null,
        primary_picture: "../../../assets/images/placeholder-img_2.jpg"
      },
      0
    );
  }

  // manages errors from submitting
  handleSubmittingErrors(
    err: TimeoutError | HttpErrorResponse,
    form: FormGroup,
    button: HTMLButtonElement
  ) {
    if (err instanceof TimeoutError) {
      button.innerText = "SUBMIT";
      this.generalservice.errorNotification(
        "Could not add the catalogue. Please check your internet and try again"
      );
      form.reset();
      this.arrayOfPicturesAttachedToCatalogue = [];
      this.arrayOfPicturesAttachedToCatalogue = Array(10);
      this.fillUpArrayWithDummyPictures();
      return;
    }

    button.innerText = "SUBMIT";
    this.generalservice.errorNotification(
      "Oops something went wrong. Please try again later"
    );
    form.reset();
    this.arrayOfPicturesAttachedToCatalogue = [];
    this.arrayOfPicturesAttachedToCatalogue = Array(10);
    this.fillUpArrayWithDummyPictures();
  }

  // starts the edit process
  setEditingInMotion(something: SimpleChange) {
    let temp: MerchantItems[] = [],
      diff: number = 0;
    const { mode, payload } = something.currentValue;
    this.name.patchValue(payload.name);
    this.description.patchValue(payload.description);
    this.mockstore.editCatalogueMode = true;
    this.catalogueInEditMode = payload;
    temp = payload.items;
    diff = this.arrayOfPicturesAttachedToCatalogue.length - temp.length;
    for (let i = 0; i < diff; i++) {
      const obj = this.arrayOfPicturesAttachedToCatalogue[i];
      temp.push(obj);
    }
    this.arrayOfPicturesAttachedToCatalogue.splice(
      0,
      this.arrayOfPicturesAttachedToCatalogue.length
    );
    this.arrayOfPicturesAttachedToCatalogue = [...temp];
    document.getElementById("submitBtn").innerText = "EDIT";
  }

  submitEditedCatalogue(
    formToSubmit,
    id: any,
    form: FormGroup,
    button: HTMLButtonElement
  ) {
    console.log(this.itemsSelected);
    // this.commservice.editACatalogue(formToSubmit, id).subscribe(
    //   val => {
    //     this.handleSuccessfulSubmit(val, form, button);
    //   },
    //   err => this.handleSubmittingErrors(err, form, button)
    // );
  }

  handleSuccessfulSubmit(val, form: FormGroup, button: HTMLButtonElement) {
    const { message } = val;
    this.generalservice.successNotification(message);
    this.generalservice.refreshCataloguesOrItems("refreshCatalogue");
    form.reset();
    this.arrayOfPicturesAttachedToCatalogue = [];
    this.arrayOfPicturesAttachedToCatalogue = Array(10);
    this.fillUpArrayWithDummyPictures();
    button.innerText = "EDIT";
    if (this.mockstore.editCatalogueMode) {
      // this is very bad practise, make sure to refactor later.
      (document.getElementById(
        "closeGeneralModal"
      ) as HTMLButtonElement).click();
      this.mockstore.editCatalogueMode = false;
      this.catalogueInEditMode = undefined;
      return;
    }

    button.innerText = "SUBMIT";
  }

  switchFromViewModeToEditMode(catalogueInViewMode) {
    const { name, description, items } = catalogueInViewMode;
    this.name.patchValue(name);
    this.description.patchValue(description);
    this.arrayOfPicturesAttachedToCatalogue.splice(0, items.length);
    items.forEach(element => {
      this.arrayOfPicturesAttachedToCatalogue.unshift(element);
    });

    this.mockstore.viewCatalagueMode = false;
    this.mockstore.editCatalogueMode = true;
    document.getElementById("submitBtn").innerText = "EDIT";
  }

  ngOnDestroy() {
    if (this.destroyItems) {
      this.destroyItems.unsubscribe();
    }
  }
}
